import { ModuleWithProviders, NgModule } from '@angular/core';
import { SellerFeatureModule } from './seller-feature.module';
import { LayoutModule } from '../layout';
import { SellerRoutingModule } from './seller-routing.module';
import { PdToNpdFlowComponent } from './pages/pd-to-npd-flow/pd-to-npd-flow.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { CreateSellerFlowComponent } from './pages/create-seller-flow/create-seller-flow.component';
import { SellerBankDataComponent, SellerPersonalDataComponent, SellerSuccessComponent } from './components/seller-collect-data';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { CheckboxModule } from 'primeng/checkbox';
import { DictionaryItemTranslateModule } from '../shared/pipes/dictionary';

@NgModule({
  imports: [
    SharedModule,
    TranslateModule.forChild(),
    SellerRoutingModule,
    LayoutModule,
    SellerFeatureModule,
    InputNumberModule,
    InputTextModule,
    DropdownModule,
    NgxIntlTelInputModule,
    CheckboxModule,
    DictionaryItemTranslateModule,
  ],
  declarations: [
    PdToNpdFlowComponent,

    CreateSellerFlowComponent,
    SellerPersonalDataComponent,
    SellerBankDataComponent,
    SellerSuccessComponent,
  ],
})
export class SellerModule {
  static forFeature(): ModuleWithProviders<SellerFeatureModule> {
    return {
      ngModule: SellerFeatureModule,
    };
  }
}
